'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('../utils');

function ChildExpressionNode(traverse, selectors, tree, treeKey, options) {
  var selector = selectors[0];
  var targetNodeName = selector.target.value;

  function traverseChilds(exitNode, child) {
    var childName = options.getName(child);
    if (exitNode) return exitNode;
    if (childName === targetNodeName) {
      var descendants = options.getChildren(child);
      if (descendants) {
        var nextSelectors = selectors.slice(1);
        if (nextSelectors) {
          var exitTree = traverse(nextSelectors, child, undefined, options);
          if (exitTree) {
            return { name: selector.target.value, child: exitTree };
          } else {
            return false;
          }
        } else {
          return { name: targetNodeName, node: child };
        }
      } else {
        return { name: targetNodeName };
      }
    }
    return false;
  }

  return (0, _utils.reduce)(options.getChildren(tree, treeKey), traverseChilds, false);
}

exports.default = ChildExpressionNode;